import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CookieConsentContext = createContext(null);

const STORAGE_KEY = "pirate-bowling-consent";

const DEFAULT_CONSENT = {
  necessary: true,
  externalMedia: false,
};

export function CookieConsentProvider({ children }) {
  const [consent, setConsent] = useState(null);
  const [bannerVisible, setBannerVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setConsent(JSON.parse(stored));
      } catch {
        setBannerVisible(true);
      }
    } else {
      setBannerVisible(true);
    }
  }, []);

  const acceptAll = useCallback(() => {
    const full = { necessary: true, externalMedia: true };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(full));
    setConsent(full);
    setBannerVisible(false);
  }, []);

  const acceptNecessary = useCallback(() => {
    const minimal = { ...DEFAULT_CONSENT };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(minimal));
    setConsent(minimal);
    setBannerVisible(false);
  }, []);

  const saveCustom = useCallback((custom) => {
    const merged = { ...DEFAULT_CONSENT, ...custom, necessary: true };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    setConsent(merged);
    setBannerVisible(false);
  }, []);

  const reopenBanner = useCallback(() => {
    setBannerVisible(true);
  }, []);

  return (
    <CookieConsentContext.Provider
      value={{ consent, bannerVisible, acceptAll, acceptNecessary, saveCustom, reopenBanner }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
}

export function useCookieConsent() {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error("useCookieConsent must be used within CookieConsentProvider");
  return ctx;
}
